let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bLlwt")).then(() => parcelRequire('7TATF'));